import { bugsnagClientNotify } from "../components/bugsnag/bugsnag-client";

export const getRecaptchaToken = async (action) => {
    try {
        const keyId = $('#ml-recaptcha-script').data('key');
        await grecaptcha.enterprise.ready();
        return await grecaptcha.enterprise.execute(keyId, { action });
    } catch (error) {
        bugsnagClientNotify('getRecaptchaToken was not successful', error);
        return 'no-recaptcha-token';
    }
};
